module.exports = __webpack_public_path__ + "img/header-map.be86e138.svg";